'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _util = require('../../util');

var _util2 = _interopRequireDefault(_util);

var _strftime = require('strftime');

var _strftime2 = _interopRequireDefault(_strftime);

var _calendar = require('../calendar');

var _lodashCompat = require('lodash-compat');

var _trigger = require('../../trigger');

var _trigger2 = _interopRequireDefault(_trigger);

var _data = require('../../util/data');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

//FIXME css里的前缀，之后可能会改
var basicPrefixCls = 'date-picker';
var getCls = function getCls(prefix, basic, suffix) {
  return [prefix + '-' + basic, basic].map(function (item) {
    return '' + item + suffix;
  }).join(' ');
};

/**
 * 日期选择器
 * props.value
 * props.placeholder = ''
 * //显示的时间格式，基于strftime，分隔符不限，'%Y-%m'|'%Y-%m-%d'|'%Y-%m-%d %H:%M'|'%Y-%m-%d %H:%M:%S'
 * props.format = '%Y-%m-%d'
 * props.required = false //是否必须
 * props.disabled = false //是否不可用
 * props.disabledDate = (ts) => { return true|false } //日期是否可用，对于月份选择来说ts是当月1日0点
 * props.onChange
 * props.prefixCls = 'mt' //类前缀
 * props.getPopupContainer = () => document.body //弹出框的父级
 * props.validation = '' //必填校验时的提示
 * props.validator = (value) => { return '123'|others } //其他校验，如果返回有文本值的字符串，则校验不通过，该字符串为提示文本
 * props.mode = 'default' // 'default'|'view' 默认模式|查看模式
 * props.emptyLabel = '' //查看模式下值空时的显示
 *
 */
var DatePicker = (_temp = _class = function (_Component) {
  _inherits(DatePicker, _Component);

  function DatePicker(props) {
    _classCallCheck(this, DatePicker);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(DatePicker).call(this, props));

    _this.state = {
      value: _this._formatValue(props.value),
      showCalendar: false,
      valid: true,
      explain: ''
    };
    return _this;
  }

  _createClass(DatePicker, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (!(0, _data.isEmptyString)(this.props.defaultValue) && (0, _data.isEmptyString)(this.state.value)) {
        var value = this._formatValue(this.props.defaultValue);
        this.setState({ value: value });
      }
      this.hideCalendar = function (e) {
        if (!_this2.state.showCalendar) {
          return;
        }
        var $container = _this2.refs.container;
        var $trigger = _this2.refs.trigger && _this2.refs.trigger.getPopupDOMNode();
        if ($container && !$container.contains(e.target) && (!$trigger || !$trigger.contains(e.target))) {
          _this2._toggleCalendar(false);
          _this2._isValid();
        }
      };
      window.addEventListener('click', this.hideCalendar);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var value = this.state.value;

      if (nextProps.hasOwnProperty('value')) {
        value = this._formatValue(nextProps.value);
      }
      this.setState({ value: value });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('click', this.hideCalendar);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props;
      var prefixCls = _props.prefixCls;
      var size = _props.size;
      var format = _props.format;
      var placeholder = _props.placeholder;
      var required = _props.required;
      var disabled = _props.disabled;
      var disabledDate = _props.disabledDate;
      var className = _props.className;
      var mode = _props.mode;
      var emptyLabel = _props.emptyLabel;
      var getPopupContainer = _props.getPopupContainer;
      var clearIcon = _props.clearIcon;
      var trigger = _props.trigger;
      var _state = this.state;
      var value = _state.value;
      var showCalendar = _state.showCalendar;
      var valid = _state.valid;
      var explain = _state.explain;


      if (mode == 'view') {
        return _react2.default.createElement(
          'div',
          { className: _util2.default.classNames(className, getCls(prefixCls, basicPrefixCls, ''), basicPrefixCls + '-view', size === "small" && basicPrefixCls + '-sm') },
          !value ? emptyLabel : (0, _strftime2.default)(format, new Date(value))
        );
      } else {
        var _M$classNames;

        //className FIXME 每次render都会算一遍
        var containerCls = getCls(prefixCls, basicPrefixCls, '');
        var showFieldCls = getCls(prefixCls, basicPrefixCls, '-show-field');
        var placeholderCls = getCls(prefixCls, basicPrefixCls, '-placeholder');
        var showValueCls = getCls(prefixCls, basicPrefixCls, '-show-value');
        var calendarMarkCls = getCls(prefixCls, basicPrefixCls, '-calendar-mark');
        var clearBtnCls = getCls(prefixCls, basicPrefixCls, '-clear-btn');
        var explainCls = getCls(prefixCls, basicPrefixCls, '-explain');
        var calendarCls = getCls(prefixCls, basicPrefixCls, '-calendar');

        var calendarContent = void 0;
        var calendarProps = {
          value: value, prefixCls: prefixCls, disabledDate: disabledDate,
          onSelect: function onSelect(v) {
            _this3._selectHandler(v, _this3._toggleCalendar.bind(_this3, false));
          }
        };
        if (format.indexOf('%H') != -1) {
          Object.assign(calendarProps, {
            format: format,
            disabledDate: this._disabledDate.bind(this),
            disabledHours: this._disabledHours.bind(this),
            disabledMinutes: this._disabledMinutes.bind(this),
            disabledSeconds: this._disabledSeconds.bind(this),
            //确认时触发onChange并收起下拉
            onConfirm: function onConfirm(v) {
              _this3._selectHandler(v, _this3._toggleCalendar.bind(_this3, false));
            }
          });
          switch (trigger) {
            case 'onSelect':
              //如果是选择时触发，则选择和确认时都触发
              Object.assign(calendarProps, {
                onSelect: this._selectHandler.bind(this)
              });
              break;
            case 'onConfirm':
              //如果是确认时触发，则选择时什么都不发生
              Object.assign(calendarProps, {
                onSelect: undefined
              });
              break;
          }
          calendarContent = _react2.default.createElement(_calendar.DateTimeCalendar, calendarProps);
        } else {
          if (format.indexOf('%d') == -1) {
            calendarContent = _react2.default.createElement(_calendar.MonthCalendar, calendarProps);
          } else {
            calendarContent = _react2.default.createElement(_calendar.DateCalendar, calendarProps);
          }
        }

        return _react2.default.createElement(
          'div',
          { ref: 'container', className: _util2.default.classNames(className, containerCls, (_M$classNames = {}, _defineProperty(_M$classNames, basicPrefixCls + '-disabled', disabled), _defineProperty(_M$classNames, basicPrefixCls + '-required', required), _defineProperty(_M$classNames, basicPrefixCls + '-focused', showCalendar), _defineProperty(_M$classNames, basicPrefixCls + '-sm', size === "small"), _defineProperty(_M$classNames, basicPrefixCls + '-invalid', !valid), _defineProperty(_M$classNames, 'has-error', !valid), _M$classNames)) },
          _react2.default.createElement(
            'div',
            { className: showFieldCls,
              onClick: !disabled && this._toggleCalendar.bind(this, true) },
            !value && placeholder && _react2.default.createElement(
              'div',
              { className: placeholderCls },
              placeholder
            ),
            value && _react2.default.createElement(
              'div',
              { className: showValueCls },
              (0, _strftime2.default)(format, new Date(value))
            ),
            _react2.default.createElement('span', { className: _util2.default.classNames(calendarMarkCls, _data.IconPrefixCls + ' ' + _data.IconPrefixCls + '-calendar') }),
            !disabled && value && clearIcon && _react2.default.createElement('span', { className: _util2.default.classNames(clearBtnCls, _data.IconPrefixCls + ' ' + _data.IconPrefixCls + '-cross-circle'),
              onClick: this._deleteHandler.bind(this) })
          ),
          _react2.default.createElement(
            _trigger2.default,
            { ref: 'trigger',
              prefixCls: prefixCls,
              className: basicPrefixCls + '__trigger',
              visible: showCalendar,
              align: {
                points: ['tl', 'bl'],
                offset: [0, 2],
                overflow: {
                  adjustX: 1,
                  adjustY: 1
                }
              },
              equalTargetWidth: false,
              getPopupContainer: getPopupContainer,
              target: this._getRootTarget.bind(this) },
            _react2.default.createElement(
              'div',
              { className: calendarCls },
              calendarContent
            )
          ),
          !!explain && _react2.default.createElement(
            'div',
            { className: 'has-explain ' + explainCls },
            explain
          )
        );
      }
    }
  }, {
    key: '_formatValue',
    value: function _formatValue(v) {
      if (!v) return undefined;
      return parseInt(v);
    }
  }, {
    key: '_onFocus',
    value: function _onFocus() {
      var onFocus = this.props.onFocus;

      onFocus && onFocus();
    }
  }, {
    key: '_onBlur',
    value: function _onBlur() {
      var onBlur = this.props.onBlur;

      onBlur && onBlur();
    }

    /**
     * 传入DateTimeCalendar
     * 用于日期面板的禁用展示
     * @param ts
     * @private
     */

  }, {
    key: '_disabledDate',
    value: function _disabledDate(ts) {
      var disabledDate = this.props.disabledDate;

      if (!disabledDate) {
        return false;
      }

      //如果这个时间戳当天都被禁用，这个日期才真的被禁用
      var date = new Date(ts);
      var isStartDayDisabled = false,
          isEndDayDisabled = false;
      date.setHours(0, 0, 0, 0);
      isStartDayDisabled = disabledDate(date.getTime());
      date.setHours(23, 59, 59, 0);
      isEndDayDisabled = disabledDate(date.getTime());

      return isStartDayDisabled && isEndDayDisabled;
    }

    /**
     * 传入DateTimeCalendar
     * 用于时间面板的禁用展示
     * @private
     */

  }, {
    key: '_disabledHours',
    value: function _disabledHours() {
      var _props2 = this.props;
      var disabledDate = _props2.disabledDate;
      var format = _props2.format;

      if (!disabledDate) {
        return [];
      }
      var value = this.state.value;

      var date = new Date(value);

      var disabledHours = [];
      var hours = Array.from(new Array(24).keys());
      var minutes = Array.from(new Array(60).keys());
      var seconds = Array.from(new Array(60).keys());

      if (format.endsWith('%S')) {
        //时:分:秒，如果某个小时所有的分钟和秒数都被禁用，则该小时被禁用
        hours.forEach(function (h) {
          var enabled = minutes.some(function (m) {
            var secEnabled = seconds.some(function (t, s) {
              date.setHours(h, m, s, 0);
              return !disabledDate(date.getTime());
            });
            return secEnabled;
          });
          if (!enabled) {
            disabledHours.push(h);
          }
        });
      } else if (format.endsWith('%M')) {
        //时:分，如果某个小时所有的分钟都被禁用，则该小时被禁用
        hours.forEach(function (h) {
          var enabled = minutes.some(function (m) {
            date.setHours(h, m, 0, 0);
            return !disabledDate(date.getTime());
          });
          if (!enabled) {
            disabledHours.push(h);
          }
        });
      } else {
        //时，如果某个小时被禁用
        hours.forEach(function (h) {
          date.setHours(h, 0, 0, 0);
          if (disabledDate(date.getTime())) {
            disabledHours.push(h);
          }
        });
      }

      return disabledHours;
    }

    /**
     * 传入DateTimeCalendar
     * 用于时间面板的禁用展示
     * @private
     */

  }, {
    key: '_disabledMinutes',
    value: function _disabledMinutes(hour) {
      var _props3 = this.props;
      var disabledDate = _props3.disabledDate;
      var format = _props3.format;

      if (!disabledDate) {
        return [];
      }
      var value = this.state.value;

      var date = new Date(value);
      var minutes = Array.from(new Array(60).keys());
      var seconds = Array.from(new Array(60).keys());

      var disabledMinutes = [];
      if (format.endsWith('%S')) {
        //时:分:秒，如果某个分钟所有的秒数都被禁用，则该分钟被禁用
        minutes.forEach(function (m) {
          var enabled = seconds.some(function (s) {
            date.setHours(hour, m, s, 0);
            return !disabledDate(date.getTime());
          });
          if (!enabled) {
            disabledMinutes.push(m);
          }
        });
      } else {
        //时:分，如果某个分钟被禁用
        minutes.forEach(function (m) {
          date.setHours(hour, m, 0, 0);
          if (disabledDate(date.getTime())) {
            disabledMinutes.push(m);
          }
        });
      }

      return disabledMinutes;
    }

    /**
     * 传入DateTimeCalendar
     * 用于时间面板的禁用展示
     * @private
     */

  }, {
    key: '_disabledSeconds',
    value: function _disabledSeconds(hour, minute) {
      var disabledDate = this.props.disabledDate;

      if (!disabledDate) {
        return [];
      }
      var value = this.state.value;

      var date = new Date(value);
      var seconds = Array.from(new Array(60).keys());

      var disabledSeconds = [];
      //时:分:秒，如果某个秒数被禁用
      seconds.forEach(function (s) {
        date.setHours(hour, minute, s, 0);
        if (disabledDate(date.getTime())) {
          disabledSeconds.push(s);
        }
      });

      return disabledSeconds;
    }

    // 供Trigger使用, 获得当前DOM元素来定位弹框

  }, {
    key: '_getRootTarget',
    value: function _getRootTarget() {
      return (0, _reactDom.findDOMNode)(this);
    }
  }, {
    key: '_toggleCalendar',
    value: function _toggleCalendar(on) {
      var showCalendar = this.state.showCalendar;

      if (showCalendar !== on) {
        this.setState({
          showCalendar: on
        });
      }
      if (on) {
        this.clear();
        this._onFocus();
      } else {
        this._onBlur();
      }
    }
  }, {
    key: '_selectHandler',
    value: function _selectHandler(value, cb) {
      var _this4 = this;

      var _props4 = this.props;
      var disabledDate = _props4.disabledDate;
      var format = _props4.format;

      if (disabledDate) {
        (function () {
          //如果选中的是被禁用的时间，则从当前日期0点开始向后查找到第一个没被禁用的时间点
          var date = new Date(value);
          if (disabledDate(date.getTime())) {
            (function () {
              var hours = Array.from(new Array(24).keys());
              var minutes = Array.from(new Array(60).keys());
              var seconds = Array.from(new Array(60).keys());
              var enabledHour = void 0,
                  enabledMinute = 0,
                  enabledSecond = 0;
              if (format.endsWith('%S')) {
                hours.find(function (h) {
                  var hIndex = minutes.findIndex(function (m) {
                    var mIndex = seconds.findIndex(function (s) {
                      date.setHours(h, m, s, 0);
                      var enabled = !disabledDate(date.getTime());
                      if (enabled) {
                        enabledHour = h;
                        enabledMinute = m;
                        enabledSecond = s;
                      }
                      return enabled;
                    });
                    return mIndex != -1;
                  });
                  return hIndex != -1;
                });
              } else if (format.endsWith('%M')) {
                hours.find(function (h) {
                  var hIndex = minutes.findIndex(function (m) {
                    date.setHours(h, m, 0, 0);
                    var enabled = !disabledDate(date.getTime());
                    if (enabled) {
                      enabledHour = h;
                      enabledMinute = m;
                    }
                    return enabled;
                  });
                  return hIndex != -1;
                });
              } else {
                enabledHour = hours.find(function (h) {
                  date.setHours(h, 0, 0, 0);
                  return !disabledDate(date.getTime());
                });
              }
              date.setHours(enabledHour, enabledMinute, enabledSecond, 0);
              value = date.getTime();
            })();
          }
        })();
      }

      this.setState({
        value: value
      }, this._isValid.bind(this, function () {
        _this4._changeHandler();
        cb && cb();
      }));
    }
  }, {
    key: '_deleteHandler',
    value: function _deleteHandler(e) {
      this.setState({
        value: undefined,
        showCalendar: false
      }, this._isValid.bind(this, this._changeHandler));
      //阻止冒泡，防止触发点击事件
      e.stopPropagation();
    }
  }, {
    key: '_changeHandler',
    value: function _changeHandler() {
      var onChange = this.props.onChange;

      onChange(this.state.value);
    }
  }, {
    key: '_isValid',
    value: function _isValid(callback) {
      var _props5 = this.props;
      var required = _props5.required;
      var validation = _props5.validation;
      var validator = _props5.validator;
      var value = this.state.value;


      var valid = true,
          explain = '';
      if (required && !value) {
        valid = false;
        explain = validation;
      } else if ((0, _lodashCompat.isFunction)(validator)) {
        var _result = validator(value);
        if (_result === false || (0, _lodashCompat.isString)(_result) && _result.length > 0) {
          valid = false;
          explain = _result || '';
        }
      }
      this.setState({ valid: valid, explain: explain }, callback);

      return valid;
    }

    /**
     * 调用本组件的校验
     * @returns {*}
     */

  }, {
    key: 'validate',
    value: function validate() {
      return this._isValid();
    }

    /**
     * 清空异常状态  校验提示等
     */

  }, {
    key: 'clear',
    value: function clear() {
      this.setState({ valid: true, explain: '' });
    }

    /**
     * 重置控件，清空数据并清空校验状态
     */

  }, {
    key: 'reset',
    value: function reset() {
      var _this5 = this;

      if (this.props.mode !== "view") {
        (function () {
          var resetValue = _this5._formatValue(_this5.props.defaultValue);
          _this5.setState({ value: resetValue, valid: true, explain: "" }, function () {
            _this5.props.onChange(resetValue);
          });
        })();
      }
    }
  }]);

  return DatePicker;
}(_react.Component), _class.propTypes = {
  value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  placeholder: _propTypes2.default.string,
  format: _propTypes2.default.string,
  required: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  disabledDate: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  prefixCls: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['default', 'small']),
  getPopupContainer: _propTypes2.default.func,
  validation: _propTypes2.default.string,
  validator: _propTypes2.default.func,
  mode: _propTypes2.default.oneOf(['default', 'view']),
  emptyLabel: _propTypes2.default.string,
  clearIcon: _propTypes2.default.bool,
  // 以下三种属性仅提供给Records.Complex使用，不对外开放，未来可能会去掉
  onFocus: _propTypes2.default.func, //单击聚焦时，默认为单击输入框出现日历下拉时
  onBlur: _propTypes2.default.func, //单击输入框之外的，包括选中、单击外部等收起日历下拉时
  trigger: _propTypes2.default.oneOf(['onSelect', 'onConfirm']) }, _class.defaultProps = {
  placeholder: '',
  format: '%Y-%m-%d',
  required: false,
  disabled: false,
  onChange: _lodashCompat.noop,
  prefixCls: 'mt',
  size: 'default',
  getPopupContainer: null,
  mode: 'default',
  emptyLabel: '',
  clearIcon: true,
  trigger: 'onSelect'
}, _temp);
exports.default = DatePicker;